module.exports = __webpack_public_path__ + "static/media/Premium_Hospitality.617ffcbf.png";